interface UnreadBadgeProps {
  count: number;
  /** Konumlandırma sınıfı; mutlak konum gerekmiyorsa "static" verilebilir. */
  className?: string;
  /** Sayı yerine sadece nokta göster. */
  dot?: boolean;
}

/** Okunmamış bildirim rozeti. */
const UnreadBadge = ({ count, className = "", dot = false }: UnreadBadgeProps) => {
  if (count <= 0) return null;

  if (dot) {
    return (
      <span
        aria-hidden
        className={`h-2 w-2 rounded-full bg-primary ring-2 ring-background ${className}`}
      />
    );
  }

  return (
    <span
      className={`min-w-[16px] h-[16px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold leading-none inline-flex items-center justify-center ${className}`}
    >
      {count > 9 ? "9+" : count}
    </span>
  );
};

export default UnreadBadge;
